import { useState } from 'react'
import { useSelector } from 'react-redux'
import SlideUp from 'common-components/SlideUp'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import AvatarActionButton from '../action-btn/AvatarActionButton'
import * as Styled from './styled'

// Opens the current source image at full size: a centered Popup on desktop, a
// bottom-sheet SlideUp on mobile (a centered popup is too small there; the
// sheet is the same mobile idiom as the Resize/Enhance panels, sitting above
// the 64px bottom tab bar). Pure viewing — no redux writes, so it's safe for
// every avatar source.
const PreviewAvatarButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const avatar = useSelector(aiAvatarSelectors.avatar)
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const close = () => setIsOpen(false)

  // Natural ratio, when known (uploads / My-Files) — lets the styled image
  // upscale low-resolution sources to the viewport instead of rendering them
  // at their tiny natural size. Public presets have no dims → undefined →
  // natural-size fallback (they are high-res anyway).
  const aspectRatio =
    avatar?.width && avatar?.height ? avatar.width / avatar.height : undefined

  return (
    <>
      <AvatarActionButton
        icon={<Styled.PreviewIcon />}
        tooltipText={translate(T.PREVIEW)}
        onClick={() => setIsOpen(true)}
        testId="avatar-preview-enlarge"
      />
      {isMobile ? (
        <SlideUp isOpen={isOpen} onClose={close}>
          <Styled.PreviewSlideUpBody>
            {avatar?.url && (
              <Styled.PreviewSlideUpImage
                src={avatar.url}
                alt="Avatar preview"
                $aspectRatio={aspectRatio}
              />
            )}
          </Styled.PreviewSlideUpBody>
        </SlideUp>
      ) : (
        <Styled.PreviewPopup isOpen={isOpen} onClose={close}>
          {avatar?.url && (
            <Styled.PreviewImage
              src={avatar.url}
              alt="Avatar preview"
              $aspectRatio={aspectRatio}
            />
          )}
        </Styled.PreviewPopup>
      )}
    </>
  )
}

export default PreviewAvatarButton
